define([
    'uiComponent',
    '../model/global-media-controls',
    'ko'
], (Component, mediaControls, ko) => {
    'use strict';
    function tapToUnmuteVisible () {
        const mainVideo = mediaControls.mainVideo();
        return mainVideo && !mainVideo.playWithAudioPermission() && !mainVideo.isMuted();
    }

    return Component.extend({

        grantAudioPermission: function () {
            mediaControls.mainVideo().playWithAudioPermission(true);
        },

        tapToUnmuteVisible: ko.pureComputed(tapToUnmuteVisible),

        muteVisible: ko.pureComputed(() => !tapToUnmuteVisible() && !mediaControls.muted()),

        unmuteVisible: ko.pureComputed(() => !tapToUnmuteVisible() && mediaControls.muted()),

        toggleMute: function () {
            mediaControls.muted(!mediaControls.muted());
        }
    });
});
